module.exports = __webpack_public_path__ + "img/no-pdf-icon.2991624c.png";